/** Shared layout dimensions for app navigation drawer */
/** Fixed v-app-bar height (AppHeader); keep in sync with advanced-search drawer offset in AdvancedSearchDrawer.vue */
export const APP_HEADER_HEIGHT = 64;
export const NAVIGATION_DRAWER_WIDTH = 260;
export const NAVIGATION_DRAWER_MINI_WIDTH = 56;
